import React from 'react';
import { Segmented, Space, Typography, Button } from 'antd';
import { useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { SegmentedValue } from 'antd/es/segmented';
import { activeFilterAtom } from './webhooksAtom';
import { StyledWebhooksHeader } from './styled';
import { getWebhooksCountConfig } from './utils';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@src/store/common/selectors';

const { Title } = Typography;
const { baseUrl } = window.conviva;

const WebhooksHeader = ({ webhookList }) => {
  const navigate = useNavigate();
  const isAdminUser = useSelector(isAdminRoleSelector);
  const setActiveFilter = useSetAtom(activeFilterAtom);
  const countConfig = getWebhooksCountConfig(webhookList);

  const addWebhooks = () => {
    navigate(`${baseUrl}/settings/webhooks/edit`);
  };

  const options = Object.keys(countConfig).map((key) => {
    return {
      label: (
        <Space align="center" direction="vertical" className="label-container">
          <Title level={5}>{countConfig[key].label}</Title>
          <Title level={4}>{countConfig[key].count}</Title>
        </Space>
      ),
      value: key,
    };
  });

  return (
    <StyledWebhooksHeader>
      <Space className="segmented-container" direction="vertical" align="start">
        <Segmented
          block
          options={options}
          onChange={(value: SegmentedValue): void => setActiveFilter(value)}
        />
      </Space>
      {isAdminUser ? (
        <Space className="quick-links-container" align="end">
          <Button type="primary" onClick={() => addWebhooks()}>
            Add Webhooks
          </Button>
        </Space>
      ) : null}
    </StyledWebhooksHeader>
  );
};

export default WebhooksHeader;
